import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, Component, computed, EventEmitter, inject
  , input, OnDestroy, OnInit, Output, signal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TextAreaModule } from '@syncfusion/ej2-angular-inputs';
import { ActionStatus, ActionType, IActions } from '../../../utilities';
import { CacActionService } from '../../../cac.action.service';
import { ItmToastrService } from '@itm/services';
import { ItmBaseComponent } from '@itm/components/itm.base.component';

@Component({
    selector: 'applyeasy-sidebar',
    templateUrl: './applyeasy-sidebar.component.html',
    styleUrls: ['./applyeasy-sidebar.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      MatInputModule,
      TextAreaModule,
      FormsModule
    ],
    providers: [],
})
export class ApplyEasySidebarComponent extends ItmBaseComponent implements OnInit, OnDestroy {

  @Output() fireResolveWithCustomerEvent = new EventEmitter<any>();

  actionData = input<IActions>();
  ActionType = ActionType;
  ActionStatus = ActionStatus;

  customerId = signal<string>('');
  submitting = signal<boolean>(false);

  isResolved = computed(() => {
    const status = this.actionData()?.status;
    return status === ActionStatus.Resolve
      || status === ActionStatus.AutoResolve
      || status === ActionStatus.Resolved;
  });

  savedCustomerId = computed(() => {
    return this.actionData()?.additional?.customerId;
  });

  private readonly _cacService = inject(CacActionService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    const saved = this.actionData()?.additional?.customerId;
    if (saved) {
      this.customerId.set(saved);
    }
  }

  ngOnDestroy(): void {
  }

  onResolveClick() {
    const raw = this.customerId().trim();
    if (!raw) {
      this._toastr.showInfo('Please enter a Customer ID.');
      return;
    }

    const customerIdNum = Number(raw);
    if (!Number.isInteger(customerIdNum) || customerIdNum <= 0) {
      this._toastr.showInfo('Customer ID must be a valid positive number.');
      return;
    }

    this.submitting.set(true);
    this._cacService.applyEasyResolve<any>(this.actionData()?.id, customerIdNum).subscribe({
      next: (resp: any) => {
        this.submitting.set(false);
        if (resp?.data?.result === true) {
          this._toastr.showSuccess('Successfully resolved with Customer ID.');
          this.fireResolveWithCustomerEvent.emit();
        } else {
          this._toastr.showWarning('Customer ID saved but the application update failed. Status set to In-Progress.');
          this.fireResolveWithCustomerEvent.emit();
        }
      },
      error: (error: any) => {
        this.submitting.set(false);
        this._toastr.showError(`Something went wrong. Error: ${error}`);
      }
    });
  }
}
